export enum SubscriptionType {
  Month = 0,
  Year = 1,
}
